exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._1eN94FfatbCko5uUefAU47{padding-top:10px}html[dir=ltr] ._1eN94FfatbCko5uUefAU47{margin-left:52px}html[dir=rtl] ._1eN94FfatbCko5uUefAU47{margin-right:52px}", ""]);
// Exports
exports.locals = {
	"translationFeedback": "_1eN94FfatbCko5uUefAU47"
};